import { useIntl } from "react-intl";
import { useNotifier, withConfiguration } from "../../context";
import { withUser } from "../../wrappers";
import { userShape } from "../../shapes";
import { htmlButton } from "../../utils";
import { useApi } from "../../hooks";
import Loader from "../Loader";

type NavigationDemoDataBannerProps = {
  user: userShape;
  configuration: {
    baseUrl?: string;
  };
};

export function NavigationDemoDataBanner({
  user,
  configuration,
}: NavigationDemoDataBannerProps) {
  const notifier = useNotifier();
  const intl = useIntl();
  const api = useApi();
  const {
    mutate: deleteDemoData,
    isSuccess,
    isLoading,
  } = api.delete.useMutation("/users/current/demo_data");

  const deactivateDemoData = async () => {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    deleteDemoData(null, {
      onSuccess: () => {
        notifier.showSuccess(
          intl.formatMessage({
            id: "navigation.demo_data_deactivation_success_notification",
          }),
        );
        setTimeout(() => {
          // @ts-expect-error TS(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
          window.location.href = configuration.baseUrl;
        }, 2000);
      },
    });
  };

  return (user as $TSFixMe)?.demoDataActive && !isSuccess ? (
    <div
      id="demo-data-banner"
      className="cyan-stripe navigation-banner-container"
    >
      <div className="navigation-banner">
        <div>
          <span className="lcm-iot-icon-info" />
          <Loader loading={isLoading} />
          <p id="banner-message">
            {!isLoading &&
              intl.formatMessage(
                { id: "root.demo_data_in_use" },
                { a: htmlButton(() => deactivateDemoData()) },
              )}
          </p>
        </div>
      </div>
    </div>
  ) : null;
}

export default withConfiguration(withUser(NavigationDemoDataBanner));
